module.exports = __webpack_public_path__ + "img/cleanHandProx.2fb20d43.jpg";